import { useContext } from 'react'
import { useWidth } from './Look + Feel'
import { AppData, AppDispatch } from './Model'

let PROFILE = ''
if (window.location.hostname === process.env['REACT_APP_PRIMARY_HOSTNAME']) PROFILE = 'PRODUCTION'
else if (/vercel.app$/.test(window.location.hostname)) PROFILE = 'PREVIEW'
else PROFILE = 'LOCAL'

const mapkitToken = process.env[`REACT_APP_MAPKIT_${PROFILE}`]

export function LocationWidgetButton() {
	const width = useWidth()

	const dispatch = useContext(AppDispatch)
	const open = () => dispatch({ type: 'popover', value: 'location' })

	return width > 600
		? <button onClick={open}><span className='marker' /> Where we are</button>
		: <button onClick={() => {
			window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
			dispatch({ type: 'heading', value: 'down' })
		}}><span className='marker' /> Where we are</button>
}

export function LocationWidget() {
	const width = useWidth()
	const state = useContext(AppData)
	const dispatch = useContext(AppDispatch)
	const cancel = () => dispatch({ type: 'popover', value: null })

	if (width > 600) return state.popover === 'location' ? <div className='popover' onClick={cancel}><LocationWidgetGrid onDismiss={cancel} /></div> : null
	else return <LocationWidgetGrid />
}

function MapLink({ url, children, ...overrides }) {
	return (
		<a href={url} target='_blank' rel='noreferrer' title='Open in Maps' { ...overrides }>
			{children}
		</a>
	)
}

function LocationWidgetGrid({ onDismiss = null }) {
	const latitude = 51.022090
	const longitude = -2.581236
	const spn = '0.6309%2C0.7995'
	const snapshot = `https://snapshot.apple-mapkit.com/api/v1/snapshot?center=${latitude}%2C${longitude}&size=600x600&t=mutedStandard&colorScheme=light&spn=${spn}&token=${mapkitToken}`
	const placeID = 'Queen Camel Tennis Club'
	const ll = 'I9A7A689F5E991552' // `${latitude},${longitude}`
	const link = `maps://?q=${placeID}&ll=${ll}` // Support 99% of map link schemes
	return (
		<div className='location-widget' onClick={event => event.stopPropagation()}>
			<div className='grid'>
				<div className='map'>
					<MapLink url={link}>
						<img className='snapshot' src={snapshot} alt='Apple Maps Snapshot, light colorscheme' />
						<div className='marker'></div>
					</MapLink>
				</div>
				<div className='detail'>
					<MapLink url={link} className='title'>
						<div className='marker' />
						<h3>Queen Camel</h3>
						<div className='chiclet'>Find us!</div>
					</MapLink>
					<p>Laboris aliqua minim incididunt culpa enim sunt exercitation. Reprehenderit voluptate amet ipsum non magna excepteur ea tempor exercitation. Exercitation enim eiusmod irure consequat occaecat.</p>
					<div className='options'>
						<MapLink url={link}>Open in Maps</MapLink>
						{onDismiss && <button onClick={onDismiss}>Dismiss</button>}
					</div>
				</div>
			</div>
		</div>
	)
}
